import { render, staticRenderFns } from "./RoleFilterPills.vue?vue&type=template&id=10e870ac&scoped=true&"
import script from "./RoleFilterPills.vue?vue&type=script&lang=ts&"
export * from "./RoleFilterPills.vue?vue&type=script&lang=ts&"
import style0 from "./RoleFilterPills.vue?vue&type=style&index=0&id=10e870ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e870ac",
  null
  
)

export default component.exports